var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-12"},_vm._l((_vm.pastas),function(pasta,index){return _c('span',{key:index},[_c('a',{staticClass:"cursor",on:{"click":function($event){return _vm.selectedFolder(pasta.caminho)}}},[_vm._v(_vm._s(pasta.nome))]),_vm._v(" "),_c('span',[_vm._v("/")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }